<template>
  <div class="rounded-2xl p-5 bg-white/5 border border-white/10">
    <div class="flex items-center justify-between gap-4">
      <p class="text-sm text-gray-300">Respondidas</p>
      <p class="text-xs text-gray-500">Clique para voltar em uma pergunta</p>
    </div>

    <div class="mt-4 space-y-2 max-h-[220px] overflow-y-auto pr-1">
      <button
        v-for="(q, i) in questions"
        :key="i"
        type="button"
        class="w-full text-left rounded-xl px-4 py-3 border transition"
        :class="itemClass(i)"
        @click="$emit('jump', i)"
      >
        <div class="flex items-center gap-3">
          <span
            class="w-8 h-8 rounded-lg flex items-center justify-center text-sm font-semibold border"
            :class="badgeClass(i)"
          >
            {{ i + 1 }}
          </span>

          <div class="min-w-0 flex-1">
            <p class="text-sm text-gray-200 truncate">
              {{ q }}
            </p>

            <p
              v-if="answerLabel(i)"
              class="mt-1 text-xs"
              :class="answerLabelClass(i)"
            >
              {{ answerLabel(i) }}
            </p>
          </div>
        </div>
      </button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps({
  questions: { type: Array, required: true },
  answers: { type: Array, required: true }, // null | 0 | 1 | 1..5
  current: { type: Number, required: true },

  responseMode: {
    type: String,
    default: "binary",
  },

  options: {
    type: Array,
    default: () => [],
  },
});

defineEmits(["jump"]);

function findOptionLabel(value) {
  const option = props.options.find((item) => item.value === value);
  return option?.label || null;
}

function answerLabel(index) {
  const value = props.answers[index];

  if (value === null || value === undefined) return null;

  if (props.responseMode === "binary") {
    return value === 1 ? "SIM" : "NÃO";
  }

  return findOptionLabel(value) || `Opção ${value}`;
}

function itemClass(i) {
  const value = props.answers[i];
  const isCurrent = i === props.current;

  let base = "bg-white/0 border-white/10 hover:bg-white/5";

  if (props.responseMode === "binary") {
    if (value === 1) {
      base = "bg-green-500/10 border-green-500/30 hover:bg-green-500/15";
    } else if (value === 0) {
      base = "bg-red-500/10 border-red-500/30 hover:bg-red-500/15";
    }
  } else if (value !== null && value !== undefined) {
    base = "bg-green-500/10 border-green-500/30 hover:bg-green-500/15";
  }

  if (isCurrent) {
    base += " ring-2 ring-white/10";
  }

  return base;
}

function badgeClass(i) {
  const value = props.answers[i];

  if (props.responseMode === "binary") {
    if (value === 1) {
      return "border-green-500/40 text-green-300 bg-green-500/10";
    }

    if (value === 0) {
      return "border-red-500/40 text-red-300 bg-red-500/10";
    }

    return "border-white/10 text-gray-300 bg-white/5";
  }

  if (value !== null && value !== undefined) {
    return "border-green-500/40 text-green-300 bg-green-500/10";
  }

  return "border-white/10 text-gray-300 bg-white/5";
}

function answerLabelClass(i) {
  const value = props.answers[i];

  if (props.responseMode === "binary") {
    if (value === 1) return "text-green-300";
    if (value === 0) return "text-red-300";
  }

  return "text-green-300";
}
</script>
